export const ACCORDION_FINANCIAL_TOTALS = [
  {
    title: 'Total Land (CG01) Budget for all FY',
    label: 'landTotal',
    name: 'Land',
  },
  {
    title: 'Total Property Investment (CG01-11) for all FY',
    label: 'propertyInvestmentTotal',
    name: 'PropertyInvestment',
  },
  {
    title: 'Total Retail Investment (CG12-14) for all FY',
    label: 'retailInvestmentTotal',
    name: 'RetailInvestment',
  },
  {
    title: 'Total Retail Cost (CG15-16) for all FY',
    label: 'retailCostTotal',
    name: 'RetailCost',
  },
  {
    title: 'Total financial for all FY',
    label: 'financialTotal',
    name: 'Financial',
  },
];
